export type Env = {
  APP_VERSION: string;
  APP_API_BASE_URL: string;
  APP_CDN_BASE_URL: string;
  APP_BASE_URL: string;
  APP_SOCKET_URL: string;
  APP_ELASTIC_URL: string;
  APP_STATIC_URL: string;
  APP_STREAM_SHARE_URL: string;
  DEV?: boolean;
};

const env: Env = {
  APP_VERSION: '',
  APP_API_BASE_URL: 'https://api.debatdirect.tweedekamer.nl/api',
  APP_CDN_BASE_URL: 'https://cdn.debatdirect.tweedekamer.nl/api',
  APP_STATIC_URL: 'https://cdn.debatdirect.tweedekamer.nl/static',
  APP_BASE_URL: 'https://debatdirect.tweedekamer.nl',
  APP_SOCKET_URL: 'https://io.debatdirect.tweedekamer.nl',
  APP_STREAM_SHARE_URL: '',
  APP_ELASTIC_URL: '',
  DEV: false,
};

export const configureEnv = (options: Partial<Env>) => {
  env.APP_VERSION = options.APP_VERSION || env.APP_VERSION;
  env.APP_BASE_URL = options.APP_BASE_URL || env.APP_BASE_URL;
  env.APP_API_BASE_URL = options.APP_API_BASE_URL || env.APP_API_BASE_URL;
  env.APP_CDN_BASE_URL = options.APP_CDN_BASE_URL || env.APP_CDN_BASE_URL;
  env.APP_ELASTIC_URL = options.APP_ELASTIC_URL || env.APP_ELASTIC_URL;
  env.APP_SOCKET_URL = options.APP_SOCKET_URL || env.APP_SOCKET_URL;
  env.APP_STATIC_URL = options.APP_STATIC_URL || env.APP_STATIC_URL;
  env.APP_STREAM_SHARE_URL = options.APP_STREAM_SHARE_URL || env.APP_STREAM_SHARE_URL;
  env.DEV = options.DEV || env.DEV;
};

export default env;
